import { render, staticRenderFns } from "./ModalUnlockMessage.vue?vue&type=template&id=641ea54a&"
import script from "./ModalUnlockMessage.vue?vue&type=script&lang=js&"
export * from "./ModalUnlockMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports